import { render, staticRenderFns } from "./GoalItemDonut.vue?vue&type=template&id=65cb47b1"
import script from "./GoalItemDonut.vue?vue&type=script&lang=js"
export * from "./GoalItemDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports